import { render } from "./levels-description-placeholder.vue?vue&type=template&id=0d2ea921&scoped=true&ts=true"
import script from "./levels-description-placeholder.vue?vue&type=script&lang=ts"
export * from "./levels-description-placeholder.vue?vue&type=script&lang=ts"

import "./levels-description-placeholder.vue?vue&type=style&index=0&id=0d2ea921&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d2ea921"]])

export default __exports__